import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { BotStepViewStore } from "../../store";
import { BotStepView } from "./BotStepView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type BotStepDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const BotStepDrawerContent: React.FC<BotStepDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new BotStepViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return <BotStepView botStepViewStore={viewStore} />;
  });
